import React from 'react';

import { InfoCircleFilledIcon } from '@vlabs/icons';
import { useTranslation } from 'react-i18next';

import st from './Toast.module.sass';

export const Toast = ({
  message = undefined,
  mediaSize = undefined,
}) => {
  const { t } = useTranslation();

  return (
    <div className={st.Root}>
      <div className={st.InfoText}>
        <InfoCircleFilledIcon />
        <span>{message}</span>
      </div>

      <span className={st.ImageSize}>
        {`${t('roi.modal.panel.frame_size')} ${mediaSize.width} x ${mediaSize.height}` }
      </span>
    </div>
  );
};
